import React from 'react';
import { Flex } from 'rebass';
import { Input, InputProps } from '@rebass/forms';
import Icon from '../Icon/Icon';
import colors from '../../theme/colors';
import { FormComboGroup } from './FormComboGroup';

interface PasswordInputProps extends InputProps {
  showPassword?: boolean;
  toggleShowPassword?: any;
}

const PasswordInput = (props: PasswordInputProps): JSX.Element => {
  const { showPassword, toggleShowPassword } = props;
  return (
    <FormComboGroup ml={props.ml}>
      <Input
        type={showPassword ? 'text' : 'password'}
        variant="inputRoundedLeft"
        {...(props as any)}
        ml={undefined}
      />
      <Flex
        alignItems="center"
        bg="white"
        justifyContent="center"
        sx={{
          borderTopRightRadius: 'circle',
          borderBottomRightRadius: 'circle',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: 'fieldBorder',
          borderLeftWidth: 0,
          paddingRight: 1,
          marginTop: 3,
        }}
        width={36}
        onClick={() => toggleShowPassword()}
      >
        <Icon
          icon={showPassword ? 'eye-open' : 'eye-slash'}
          color={colors.fieldBorderHover}
          size="16"
        />
      </Flex>
    </FormComboGroup>
  );
};

export { PasswordInput };
